import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/TafsirAyat.css";
import { AiFillCloseCircle } from "react-icons/ai";

const TafsirAyat = ({ handleClose, show, nomorSurat, id }) => {
  const [tafsir, setTafsir] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTafsir = async () => {
      try {
        const response = await axios.get(
          `https://equran.id/api/v2/tafsir/${nomorSurat}`
        );
        const dataTafsir = await response?.data?.data?.tafsir;
        const data = dataTafsir.filter((tafsir) => tafsir.ayat === id)[0];
        setTafsir(data);
        setLoading(false);
      } catch (error) {
        console.error("error", error);
      }
    };

    fetchTafsir();
  }, [nomorSurat, id]);

  if (loading) {
    return <p className="loading">Sedang memuat...</p>;
  }

  const showHideClassName = show ? "popup display-block" : "popup display-none";

  return (
    <div className={showHideClassName}>
      <section className="popup-main">
        <div className="popup-header">
          <button onClick={handleClose} className="close">
            <AiFillCloseCircle className="close-icon" />
          </button>
          <div className="tafsir-title__wrapper">
            <p className="tafsir-title">TAFSIR </p>
            <p className="tafsir-desc">(ayat ke-{tafsir.ayat})</p>
          </div>
        </div>
        <p className="tafsir-detail">{tafsir.teks}</p>
      </section>
    </div>
  );
};

export default TafsirAyat;
